import React, { useState, useEffect } from 'react';
import Takeover from '../../takeover';
import classNames from 'classnames';
import { Button } from '../../forms';
import ColorPicker from '../color-picker';
import SaveButton from '../../report/save-button';
import SpinnerDots from '../../spinner/dots';
import '../create-district.scss';

function EditDistrictDialog({ district, isOpen, onClose, onSave, type }) {
    const [name, setName] = useState(district?.name || '');
    const [color, setColor] = useState(district?.color || '#ff0000');
    const [textColor, setTextColor] = useState(district?.color || '#ff0000');

    useEffect(() => {
        if (isOpen && district) {
            setName(district.name || '');
            setColor(district.color || '#ff0000');
            setTextColor(district.color || '#ff0000');
        }
    }, [isOpen, district]);

    function handleNameChange(e) {
        setName(e.currentTarget.value);
    }

    function handleColorChange(e) {
        const newColor = e.currentTarget.value;
        setColor(newColor);
        setTextColor(newColor);
    }

    function handleInputColorChange(e) {
        const newColor = e.currentTarget.value;
        if (/^#[0-9A-F]{6}$/i.test(newColor)) {
            setColor(newColor);
            setTextColor(newColor);
        } else {
            setTextColor(newColor === '' ? `#${newColor}` : newColor);
        }
    }

    function handleSave() {
        onSave({ name, color });
        onClose();
    }

    return (
            <Takeover isOpen={isOpen} toggleTakeover={onClose} heading="Ändra namn och färg">
            <div className="save-district">
                {isOpen && (
                    <div className="save-district__content-outer">
                        <div className="save-district__content">
                            <label className="create-district-map__label">Namn</label>
                            <input 
                                className="create-district-map__input" 
                                type="text" 
                                onChange={handleNameChange} 
                                value={name} 
                            />
                            <label className="create-district-map__label" htmlFor="districtcolor">
                                Färg på området i kartan, eller välj en egen
                            </label>
                            <ColorPicker 
                                color={color} 
                                textColor={textColor} 
                                onChange={handleColorChange} 
                                handleInputColorChange={handleInputColorChange} 
                                salesDistrictScenarioId={district?.salesDistrictScenarioId} 
                            />
                        </div>
                        <div className="create-district-map__forms-footer">
                            <SaveButton 
                                onClick={handleSave} 
                                disabled={!name || !color}
                                text="Klar!" 
                                modifiers={{
                                    'create-district-map__create': true,
                                    'report-save-btn--centered': true
                                }} 
                            />
                            <Button 
                                type="button" 
                                modifiers={{
                                    'form__button--muted': true,
                                    'form__button--centered': true
                                }}
                                onClick={onClose}
                            >
                                Avbryt
                            </Button>
                        </div>
                    </div>
                )}
                <SpinnerDots />
            </div>
        </Takeover>
    );
}

export default EditDistrictDialog;
